import React, { useEffect, useRef } from "react";
import styles from "../styles/Hero.module.css";
import gsap from "gsap";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import calculatorAnimation from "../assets/calculatorAnimation.lottie";

export default function Hero() {
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const buttonsRef = useRef(null);
  const badgeRef = useRef(null);
  const lottieRef = useRef(null);


  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

      tl.from(badgeRef.current, { y: 20, opacity: 0, duration: 0.6 })
        .from(
          titleRef.current.querySelectorAll(`.${styles.letter}`),
          { y: 40, opacity: 0, duration: 0.7, stagger: 0.03 },
          "-=0.3"
        )
        .from(subtitleRef.current, { y: 20, opacity: 0, duration: 0.6 }, "-=0.4")
        .from(
          buttonsRef.current.children,
          { y: 20, opacity: 0, duration: 0.6, stagger: 0.1 },
          "-=0.3"
        );
    });

	 console.log(buttonsRef.current.children);

    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.hero} id="home">
      <div className={styles.glow} />

      <div className={styles.content}>
        <div 
          className={styles.animationContainer}
          onClick={() => {
            lottieRef.current?.stop();
            lottieRef.current?.play();
          }}
        >
          <DotLottieReact
            src={calculatorAnimation}
            autoplay
            dotLottieRefCallback={(ref) => (lottieRef.current = ref)}
          />
        </div>
        <span ref={badgeRef} className={styles.badge}>
          Cyprus tax & social insurance compliant
        </span>

        <h1 ref={titleRef} className={styles.title}>
          {"Payslip made simple".split("").map((char, i) => (
            <span key={i} className={styles.letter}>
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </h1>

        <p ref={subtitleRef} className={styles.subtitle}>
          Generate accurate, law-compliant payslips for Cyprus employees in
          minutes. Enter the details, review the breakdown, and download a
          ready-to-use PDF — no signup required.
        </p>

        <div ref={buttonsRef} className={styles.buttons}>
          <button
            onClick={() => scrollToSection("payslip-form")}
            className={styles.primaryBtn}
          >
            Create your payslip
          </button>

          <button
            onClick={() => scrollToSection("about")}
            className={styles.secondaryBtn}
          >
            How it works
          </button>
        </div>
      </div>
    </section>
  );
}